import { CreateScaffoldWebConsoleCommand } from 'app/core/hub-api';

// Model for scaffold used in the scaffolds step of the import site modal.
export class SiteImportScaffold extends CreateScaffoldWebConsoleCommand {
  selected: boolean;
}
